import { PrivateBlogCategoryFactory } from './privateBlogCategoryFactory';

import type {
  PrivateBlogCategoryEntity,
  PrivateBlogCategoryProps,
} from './privateBlogCategoryEntity';
import type { PrivateBlogCategoryIRepository } from './privateBlogCategoryIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

export class PrivateBlogCategoryRepository extends AppsyncRepositoryPvt<
  PrivateBlogCategoryEntity,
  PrivateBlogCategoryProps,
  PrivateBlogCategoryJson
> implements PrivateBlogCategoryIRepository {
  private factory = new PrivateBlogCategoryFactory();

  /**
   * Entity名
   */
  protected get entityName(): EntityName {
    return EntityName.WagakoNurseryPrivateBlogCategoryEntity;
  }

  /**
   * データからEntity生成
   * @param props データ
   * @returns Entity
   */
  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
